<template>
    <div class="buy-overview">
        <el-header class="overview-header">
            <div class="header-left">
                <img src="@/assets/favicon.png" alt="" />
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">采购订单（总览）</div>
            </div>
            <div class="header-info">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }})</div>
                <div class="header-right">{{ homeDate }}</div>
            </div>
        </el-header>

        <div class="filter-card">
            <el-form :inline="true" :model="searchobj" size="small" class="filter-form">
                <el-form-item label="订单号">
                    <el-input v-model="searchobj.formId" clearable placeholder="请输入订单号" @keyup.enter.native="search" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item label="合同号">
                    <el-select style="width: 200px; font-size: 14px" clearable v-model="searchobj.projectId" filterable placeholder="选择合同号" default-first-option remote
                        :remote-method="async_projectId" :loading="loading2" @change="search">
                        <el-option v-for="item in project_options" :key="item.id" :label="item.trackNumber" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物料">
                    <el-select style="width: 200px;font-size: 14px;" clearable filterable remote value-key="materialId" v-model="searchobj.materialId" placeholder="请输入物料名称、型号、编码"
                        :remote-method="async_material" :loading="loading2" default-first-option @change="search">
                        <el-option v-for="item in material_options" :key="item.materialId" style="width: 450px;" :label="(roleName != '供应商' || roleName == '供应商' && item.nameAlias.length == 0) ?
                        (item.materialName + '--' + item.materialType) :
                        (item.nameAlias.join('--'))" :value="item.materialId">
                            <template>
                                <div style="display: flex;gap:10px">
                                    <div style="width: 50%;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">{{
                              item.materialName }}</div>
                                    <div style="width: 50%;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">{{
                              item.materialType }}</div>
                                </div>
                            </template>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="roleName != '供应商'" label="供应商">
                    <el-select v-model="searchobj.supplierId" clearable filterable remote default-first-option placeholder="输入并选择供应商" :remote-method="async_supplier"
                        :loading="loading2" style="width:200px" @change="search">
                        <el-option v-for="item in supplier_options" :key="item.id" :label="item.supplierName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="订单日期">
                    <el-date-picker v-model="orderDateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item> -->
                <el-form-item label="状态">
                    <el-select v-model="searchobj.status" clearable placeholder="全部状态" @change="search" style="width:150px;">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="接单状态">
                    <el-radio-group v-model="searchobj.acceptFlag" size="mini" @change="search">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button :label="0">未接单</el-radio-button>
                        <el-radio-button :label="1">已接单</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="filter-actions">
                    <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
                    <el-button type="success" icon="el-icon-refresh" @click="refresh">刷新</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="overview-content">
            <div class="table-section">
                <div class="table-body">
                    <el-table :data="table_data" border stripe height="100%" v-loading="table_loading" row-key="formId" :expand-row-keys="expandedRowKeys"
                        @expand-change="handleExpandChange" :header-row-style="{ height: '0' }"
                        :header-cell-style="{ background: '#fff', color: '#000', padding: '0', textAlign: 'center', height: '40px' }" :row-style="{ height: '45px' }"
                        :cell-style="{ padding: '2px 0' }">
                        <el-table-column type="expand" width="45">
                            <template slot-scope="scope">
                                <div class="detail-wrap" v-loading="scope.row.detailLoading">
                                    <div v-if="scope.row.detailFailed" class="detail-message">
                                        <span>明细加载失败</span>
                                        <el-button type="text" icon="el-icon-refresh" @click="retryDetail(scope.row)">重试</el-button>
                                    </div>
                                    <template v-else-if="scope.row.detailLoaded">
                                        <div class="detail-toolbar">
                                            <span>可选 {{ selectableDetailCount(scope.row) }} 项，已选 {{ selectedDetailCount(scope.row) }} 项</span>
                                            <el-button type="text" size="mini" :disabled="!selectableDetailCount(scope.row)" @click="toggleAllDetails(scope.row)">
                                                {{ areAllDetailsSelected(scope.row) ? "取消全选" : "全选可发" }}
                                            </el-button>
                                        </div>
                                        <el-table :data="scope.row.detailRows" border size="mini" class="detail-table" empty-text="暂无采购明细" :row-class-name="detailRowClassName"
                                            @row-click="handleDetailRowClick($event, scope.row)">
                                            <el-table-column label="选择" width="55" align="center">
                                                <template slot-scope="detailScope">
                                                    <el-checkbox :value="isDetailSelected(detailScope.row)" :disabled="!canSelectDetail(detailScope.row)" @click.native.stop
                                                        @change="toggleDetail(detailScope.row, scope.row, $event)"></el-checkbox>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="物料名称" prop="materialName" min-width="180" show-overflow-tooltip></el-table-column>
                                            <el-table-column label="规格型号/物料类型" min-width="180" show-overflow-tooltip>
                                                <template slot-scope="detailScope">{{ detailSpec(detailScope.row) }}</template>
                                            </el-table-column>
                                            <el-table-column label="编码" prop="materialBarcode" min-width="80" show-overflow-tooltip></el-table-column>
                                            <el-table-column label="需用日期" prop="useDate" min-width="80" align="center"></el-table-column>
                                            <el-table-column label="送货地址" prop="deliveryAddress" min-width="150" show-overflow-tooltip></el-table-column>
                                            <el-table-column label="备注" prop="itemRemark" min-width="180" show-overflow-tooltip></el-table-column>
                                            <el-table-column label="单位" prop="unit" min-width="60" align="center"></el-table-column>
                                            <el-table-column label="单价" prop="price" min-width="60" align="right"></el-table-column>
                                            <el-table-column label="采购数量" prop="buyNumber" min-width="60" align="right"></el-table-column>
                                            <el-table-column label="已发货" prop="outputNumber" min-width="60" align="right"></el-table-column>
                                            <el-table-column label="剩余可发" min-width="60" align="right">
                                                <template slot-scope="detailScope">{{ remainingNumber(detailScope.row) }}</template>
                                            </el-table-column>
                                            <el-table-column label="状态" min-width="60" align="center">
                                                <template slot-scope="detailScope">
                                                    <el-tag :type="detailStatusType(detailScope.row)" size="mini">{{ getDetailStatus(detailScope.row) }}</el-tag>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </template>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单号" prop="formId" min-width="160" align="left" show-overflow-tooltip sortable>
                            <template slot-scope="scope">{{showValue(scope.row.formId)}}</template>
                        </el-table-column>
                        <el-table-column label="状态" prop="acceptFlag" min-width="130" align="center" sortable>
                            <template slot-scope="scope">
                                <div style="display: flex; gap: 10%;justify-content: center;">
                                    <el-tag v-if="scope.row.acceptFlag === 1 || scope.row.acceptFlag === 0" :type="scope.row.acceptFlag === 1 ? 'success' : 'info'" size="mini">
                                        {{ scope.row.acceptFlag === 1 ? "已接单" : "未接单" }}
                                    </el-tag>
                                    <el-tag v-if="statusText(scope.row) !== '--'" :type="statusType(scope.row)" size="mini">{{ statusText(scope.row) }}</el-tag>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单日期" min-width="90" align="center" sortable :sort-method="sortOrderDate">
                            <template slot-scope="scope">{{ showDate(scope.row.createTime) }}</template>
                        </el-table-column>
                        <el-table-column label="合同号" prop="project.trackNumber" min-width="150" align="left" show-overflow-tooltip sortable></el-table-column>
                        <el-table-column label="订单金额" min-width="90" align="center" sortable>
                            <template slot-scope="scope">{{ showValue(scope.row.totalPrice) }}</template>
                        </el-table-column>
                        <el-table-column label="供应商" prop="supplier" min-width="190" align="left" show-overflow-tooltip sortable v-if="roleName != '供应商'">
                            <template slot-scope="scope">{{ supplierName(scope.row.supplier) }}</template>
                        </el-table-column>
                        <el-table-column label="附件" min-width="70" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.commonFileList && scope.row.commonFileList.length > 0">
                                    <el-dropdown trigger="click" :ref="`dropdown-${scope.row.formId}`" placement="bottom-start" :hide-on-click="false">
                                        <el-button type="text" size="media" @click.stop style="padding: 0;">
                                            查看({{ scope.row.commonFileList.length }})
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="(file, index) in scope.row.commonFileList" :key="index" class="file-item"
                                                @click.native="previewFile(file, scope.row)">
                                                <div class="file-item-row">
                                                    <span class="file-name" :title="`上传时间：${file.uploadTime}`">
                                                        {{ file.originalName }} ({{ formatFileSize(file.size) }})
                                                    </span>
                                                    <div class="file-actions">
                                                        <el-link type="success" size="mini" @click.stop="downloadFile(file)" title="下载">
                                                            <i class="el-icon-download"></i>下载
                                                        </el-link>
                                                        <el-link type="danger" size="mini" @click.stop="delFile(file)" title="删除">
                                                            <i class="el-icon-delete"></i>删除
                                                        </el-link>
                                                    </div>
                                                </div>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="150" align="center" fixed="right">
                            <template slot-scope="scope">
                                <div style="display: flex; gap: 10px;justify-content: center;">
                                    <el-link type="primary" size="small" @click="gotoDetail(scope.row)">详情</el-link>
                                    <el-link type="warning" size="small" @click="updateAcceptFlag(scope.row)">接单</el-link>
                                    <el-link type="success" size="small" @click="openUpload(scope.row)">上传附件</el-link>
                                </div>
                            </template>
                        </el-table-column>
                        <div slot="empty" class="empty-state">
                            <template v-if="loadFailed">
                                <div>采购订单加载失败</div>
                                <el-button type="text" icon="el-icon-refresh" @click="getData">重新加载</el-button>
                            </template>
                            <span v-else>暂无采购订单</span>
                        </div>
                    </el-table>
                </div>
                <div class="table-footer">
                    <el-pagination background layout="sizes, prev, pager, next, total" :total="total" :current-page="searchobj.currentPage" :page-size="searchobj.pageSize"
                        :page-sizes="[10, 30, 50, 100, 200]" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                </div>
            </div>

            <aside class="selected-panel">
                <div class="selected-header">
                    <div class="selected-title">已选明细 <el-tag size="mini">{{ selectedDetails.length }}</el-tag>
                    </div>
                    <el-button type="text" :disabled="!selectedDetails.length || submitting" @click="clearSelected">清空</el-button>
                </div>
                <div v-if="!selectedDetails.length" class="selected-empty">暂无已选明细</div>
                <div v-else class="selected-list">
                    <div v-for="item in selectedDetails" :key="item.id" class="selected-item">
                        <el-button type="text" icon="el-icon-delete" class="remove-button" title="删除" @click="removeDetail(item.id)"></el-button>
                        <div class="selected-item-head">
                            <strong>{{ showValue(item.materialName) }}</strong>
                        </div>
                        <div class="quantity-row">
                            <span :title="detailSpec(item)">{{ detailSpec(item) }}</span>
                            <el-input-number v-model="item.gen_num" :min="0" :max="remainingNumber(item)" size="mini" @change="updateDetailAmount(item)"></el-input-number>
                        </div>
                        <div class="count-row">
                            <div class="item-amount1">单价：¥ {{ formatMoney(item.price) }}</div>
                            <div class="item-amount">¥ {{ formatMoney(item.gen_totalprice) }}</div>
                        </div>
                    </div>
                </div>
                <div class="selected-summary">
                    <div><span>已选明细数</span><strong>{{ selectedDetails.length }}</strong></div>
                    <div><span>发货总数量</span><strong>{{ selectedTotalNumber }}</strong></div>
                    <div><span>预计总金额</span><strong>¥ {{ formatMoney(selectedTotalAmount) }}</strong></div>
                    <el-button type="primary" icon="el-icon-truck" :loading="submitting" :disabled="!selectedDetails.length" @click="generateSentForm">生成送货单</el-button>
                </div>
            </aside>
        </div>
        <el-footer style="height: 2%; font-size: 13px;color: #fff;">© 2024 LINKFAIRTECH 版权所有</el-footer>

        <uploadFile :uploadShow.sync="uploadShow" :currentRow="currentRow" tableName="purchase_form" @uploadClose="uploadClose" />
        <viewFileMin :file="currentViewFile" :visible="viewOffice" @updateVisible="updateVisible"></viewFileMin>
        <imageView :img_show.sync="img_show" :fileName="currentFileName" :filePath="currentFilePath" @imageClose="imageClose"></imageView>
    </div>
</template>

<script>
import { get_supplier, get_project, get_material } from "@/utils/func";
import { purchaseFormHeadQuery, purchaseFormQuery, addSentFormApi, updateAcceptFlagApi } from "@/Api/buyPageApi";
import * as fileApi from "@/Api/fileApi";
import uploadFile from "@/components/uploadFile.vue";
import viewFileMin from "@/components/viewFileMin.vue";
import imageView from "@/components/imageView.vue";

const createSearchobj = () => ({
    formId: "",
    projectId: "",
    supplierId: "",
    status: "",
    acceptFlag: "",
    pageSize: 30,
    currentPage: 1,
});

export default {
    name: "buyOverview",
    components: {
        uploadFile,
        viewFileMin,
        imageView,
    },
    data() {
        return {
            timer: "",
            homeDate: "",
            userNme: sessionStorage.getItem("userName"),
            roleName: sessionStorage.getItem("roleName"),
            searchobj: createSearchobj(),
            orderDateRange: [],
            table_data: [],
            total: 0,
            table_loading: false,
            loadFailed: false,
            expandedRowKeys: [],
            selectedDetailMap: {},
            submitting: false,
            loading2: false,
            supplier_options: [],
            statusOptions: [
                { value: 0, label: "未发货" },
                { value: 1, label: "部分发货" },
                { value: 2, label: "在途" },
                { value: 3, label: "部分签收" },
                { value: 4, label: "签收完成" },
            ],
            headerCellStyle: {
                background: "#78b5ec",
                color: "#000",
                padding: "0",
                fontWeight: "400",
                textAlign: "center",
            },
            project_options: [],
            material_options: [],
            uploadShow: false,
            currentRow: {},
            currentViewFile: {},
            viewOffice: false,
            img_show: false,
            currentFileName: "",
            currentFilePath: "",
        };
    },
    computed: {
        selectedDetails() {
            return Object.values(this.selectedDetailMap);
        },
        selectedTotalNumber() {
            return this.selectedDetails.reduce((total, item) => total + (Number(item.gen_num) || 0), 0);
        },
        selectedTotalAmount() {
            return this.selectedDetails.reduce((total, item) => total + (Number(item.gen_totalprice) || 0), 0);
        },
    },
    methods: {
        async_projectId(query) {
            get_project(this, query);
        },

        async_material(query) {
            get_material(this, query);
        },
        handleExpandChange(row, expandedRows) {
            const expanded = Array.isArray(expandedRows) ? expandedRows.some((item) => item === row || item.formId === row.formId) : Boolean(expandedRows);
            this.expandedRowKeys = expanded ? [row.formId] : [];
            if (expanded) this.loadDetailRows(row);
        },
        loadDetailRows(row) {
            if (row.detailLoading || row.detailLoaded) return;
            this.$set(row, "detailLoading", true);
            this.$set(row, "detailFailed", false);
            purchaseFormQuery({ formId: row.formId, pageSize: 1000, currentPage: 1 }, this)
                .then((res) => {
                    const records = res && Array.isArray(res.records) ? res.records : [];
                    const detailRows = records.map((item) => {
                        const detail = Object.assign({}, item, {
                            formId: item.formId || row.formId,
                            projectId: item.projectId || (row.project && row.project.id),
                            supplierId: item.supplierId || row.supplierId,
                            receiveNumber: item.receiveNumber == null ? 0 : item.receiveNumber,
                        });
                        const selected = detail.id && this.selectedDetailMap[detail.id];
                        if (selected) {
                            const genNum = selected.gen_num;
                            Object.assign(selected, detail, { gen_num: genNum });
                            this.updateDetailAmount(selected);
                        }
                        return detail;
                    });
                    this.$set(row, "detailRows", detailRows);
                    this.$set(row, "detailLoaded", true);
                })
                .catch(() => {
                    this.$set(row, "detailFailed", true);
                })
                .finally(() => {
                    this.$set(row, "detailLoading", false);
                });
        },
        retryDetail(row) {
            this.$set(row, "detailLoaded", false);
            this.$set(row, "detailFailed", false);
            this.loadDetailRows(row);
        },
        detailSpec(item) {
            return this.showValue(item.materialType || item.specification || item.specModel);
        },
        remainingNumber(item) {
            return Math.max(0, (Number(item.buyNumber) || 0) - (Number(item.outputNumber) || 0));
        },
        getDetailStatus(item) {
            const buyNumber = Number(item.buyNumber) || 0;
            const outputNumber = Number(item.outputNumber) || 0;
            const receiveNumber = item.receiveNumber == null ? 0 : Number(item.receiveNumber) || 0;
            if (outputNumber === 0) return "未发货";
            if (outputNumber > 0 && outputNumber < buyNumber) return "部分发货";
            if (receiveNumber === 0 && outputNumber === buyNumber) return "在途";
            if (receiveNumber > 0 && receiveNumber < buyNumber && outputNumber === buyNumber) return "部分签收";
            if (receiveNumber === buyNumber) return "签收完成";
            return "--";
        },
        detailStatusType(item) {
            const status = this.getDetailStatus(item);
            if (status === "未发货") return "info";
            if (status === "部分发货") return "warning";
            if (status === "签收完成") return "success";
            return "";
        },
        canSelectDetail(item) {
            const status = this.getDetailStatus(item);
            return Boolean(item.id) && (status === "未发货" || status === "部分发货");
        },
        isDetailSelected(item) {
            return Boolean(item.id && this.selectedDetailMap[item.id]);
        },
        detailRowClassName({ row }) {
            if (this.isDetailSelected(row)) return "detail-row-selected";
            if (!this.canSelectDetail(row)) return "detail-row-disabled";
            return "detail-row-selectable";
        },
        handleDetailRowClick(item, headRow) {
            if (!this.canSelectDetail(item)) return;
            this.toggleDetail(item, headRow, !this.isDetailSelected(item));
        },
        selectableDetails(headRow) {
            return (headRow.detailRows || []).filter((item) => this.canSelectDetail(item));
        },
        selectableDetailCount(headRow) {
            return this.selectableDetails(headRow).length;
        },
        selectedDetailCount(headRow) {
            return this.selectableDetails(headRow).filter((item) => this.isDetailSelected(item)).length;
        },
        areAllDetailsSelected(headRow) {
            const selectable = this.selectableDetails(headRow);
            return selectable.length > 0 && selectable.every((item) => this.isDetailSelected(item));
        },
        toggleAllDetails(headRow) {
            const selectable = this.selectableDetails(headRow);
            const shouldSelect = !this.areAllDetailsSelected(headRow);
            selectable.forEach((item) => this.toggleDetail(item, headRow, shouldSelect));
        },
        toggleDetail(item, headRow, checked) {
            if (!item.id) {
                this.$message.warning("明细ID缺失，无法选择");
                return;
            }
            if (!checked) {
                this.removeDetail(item.id);
                return;
            }
            if (!this.canSelectDetail(item)) return;
            const selected = Object.assign({}, item, {
                formId: item.formId || headRow.formId,
                projectId: item.projectId || (headRow.project && headRow.project.id),
                supplierId: item.supplierId || headRow.supplierId,
                receiveNumber: item.receiveNumber == null ? 0 : item.receiveNumber,
                gen_num: this.remainingNumber(item),
            });
            selected.gen_totalprice = (Number(selected.price) || 0) * selected.gen_num;
            this.$set(this.selectedDetailMap, item.id, selected);
        },
        removeDetail(id) {
            this.$delete(this.selectedDetailMap, id);
        },
        clearSelected() {
            this.selectedDetailMap = {};
        },
        updateDetailAmount(item) {
            const amount = (Number(item.price) || 0) * (Number(item.gen_num) || 0);
            this.$set(item, "gen_totalprice", amount);
        },
        formatMoney(value) {
            const amount = Number(value);
            return Number.isFinite(amount) ? amount.toFixed(2) : "0.00";
        },
        validateSelectedDetails() {
            if (!this.selectedDetails.length) {
                this.$message.warning("请先勾选明细");
                return false;
            }
            for (let i = 0; i < this.selectedDetails.length; i += 1) {
                const item = this.selectedDetails[i];
                const status = this.getDetailStatus(item);
                const genNum = Number(item.gen_num);
                if (status !== "未发货" && status !== "部分发货") {
                    this.$message.warning("请勾选未发货或部分发货的选项");
                    return false;
                }
                if (!Number.isFinite(genNum) || genNum <= 0 || genNum > this.remainingNumber(item)) {
                    this.$message.warning("本次发货数量必须大于0且不能超过剩余可发数量");
                    return false;
                }
            }
            return true;
        },
        async generateSentForm() {
            if (this.submitting || !this.validateSelectedDetails()) return;
            this.submitting = true;
            const addresses = [];
            this.selectedDetails.forEach((item) => {
                const address = item.deliveryAddress == null ? "" : String(item.deliveryAddress).trim();
                if (address && addresses.indexOf(address) === -1) addresses.push(address);
            });
            try {
                if (addresses.length > 1) {
                    await this.$confirm("送货地址不唯一，是否继续生成送货单？", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    });
                }
                await this.$confirm("确定生成送货单？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                });
            } catch (e) {
                this.submitting = false;
                return;
            }
            const sendList = this.selectedDetails.map((item, index) => ({
                index: index + 1,
                purchaseId: item.id,
                projectId: item.projectId,
                useDate: item.useDate,
                supplierId: item.supplierId,
                materialId: item.materialId,
                outputNumber: item.gen_num,
            }));
            addSentFormApi(sendList, this)
                .then((res) => {
                    this.$message.success("生成成功");
                    this.selectedDetailMap = {};
                    this.table_data.forEach((row) => {
                        this.$set(row, "detailRows", []);
                        this.$set(row, "detailLoaded", false);
                        this.$set(row, "detailFailed", false);
                    });
                    this.getData();
                    const { href } = this.$router.resolve({
                        path: "/sendPage_detail",
                        query: { check_list: res, check_status: 1 },
                    });
                    window.open(href, "_blank");
                })
                .catch(() => {})
                .finally(() => {
                    this.submitting = false;
                });
        },
        //更新采购订单接单状态
        updateAcceptFlag(row) {
            this.$confirm(`确认接单采购订单：${row.formId}吗？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    purchaseFormQuery({ formId: row.formId, pageSize: 999, currentPage: 1 }, this).then((res) => {
                        let submitList = res.records.map((item) => ({
                            id: item.id,
                            acceptFlag: 1,
                        }));
                        updateAcceptFlagApi(submitList, this)
                            .then(() => {
                                this.getData();
                            })
                            .catch(() => {});
                    });
                })
                .catch(() => {});
        },
        showTime() {
            this.homeDate = this.$getTime();
            this.timer = setInterval(() => {
                this.homeDate = this.$getTime();
            }, 1000);
        },
        getData() {
            this.loadFailed = false;
            this.expandedRowKeys = [];
            // this.table_data = [
            //     {
            //         id: "oCGIYixOSf+iPAg69d/vmzFxv60=",
            //         formId: "LFKJ-20260530-22924",
            //         supplierId: "dITbcW+wQzWXxQxeJYKoXDfGffw=",
            //         supplier: "鹤山市永鸿泰贸易有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA8CLuUIbpg9",
            //             trackId: "LFKJ-OPO21-0000-00-K",
            //             trackNumber: "库存备用件",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-30 14:07:35",
            //         itemCount: 18,
            //         buyNumber: 250,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 4642,
            //         status: 0,
            //     },
            //     {
            //         id: "5By/5ngURNKAmam0lxmyGjFxv60=",
            //         formId: "LFKJ-20260530-22923",
            //         supplierId: "dITbcW+wQzWXxQxeJYKoXDfGffw=",
            //         supplier: "鹤山市永鸿泰贸易有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA9u69wIbpg9",
            //             trackId: "LFKJ-NZO25-0525-01-TH",
            //             trackNumber: "LFCK/TH2025-05-25",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-30 11:19:43",
            //         itemCount: 4,
            //         buyNumber: 54,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 1073.4,
            //         status: 0,
            //     },
            //     {
            //         id: "FENtLDXLR5+CVUauo08WljFxv60=",
            //         formId: "LFKJ-20260530-22922",
            //         supplierId: "dITbcW+wQzWXxQxeJYKoXDfGffw=",
            //         supplier: "鹤山市永鸿泰贸易有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA9/Uq8Ibpg9",
            //             trackId: "LFKJ-WZO25-0908-01-W-TH",
            //             trackNumber: "LFWZ-W-2025-09-08",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-30 10:50:44",
            //         itemCount: 2,
            //         buyNumber: 2,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 185,
            //         status: 0,
            //     },
            //     {
            //         id: "m5eXg8zNQWWAhUxUvuu47jFxv60=",
            //         formId: "LFKJ-20260530-22921",
            //         supplierId: "4oIAAA+x4k83xn38",
            //         supplier: "江苏工店宝工业科技有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA+dZ3cIbpg9",
            //             trackId: "LFKJ-WZO25-1217-01-W",
            //             trackNumber: "LFWZ-W-2025-12-17",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-30 10:17:50",
            //         itemCount: 7,
            //         buyNumber: 55,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 1900,
            //         status: 0,
            //     },
            //     {
            //         id: "002WjWKOSvqDobl9YGyjUTFxv60=",
            //         formId: "LFKJ-20260530-22918",
            //         supplierId: "dITbcW+wQzWXxQxeJYKoXDfGffw=",
            //         supplier: "鹤山市永鸿泰贸易有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA+G4nQIbpg9",
            //             trackId: "LFKJ-WZO25-1102-01-W-WN",
            //             trackNumber: "LFWZ-W-2025-11-02-1",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-30 09:27:09",
            //         itemCount: 6,
            //         buyNumber: 86,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 42.8,
            //         status: 0,
            //     },
            //     {
            //         id: "A9uGGp0uRA6vbB+0z6Ro4jFxv60=",
            //         formId: "LFKJ-20260530-22917",
            //         supplierId: "4oIAAA8M+4g3xn38",
            //         supplier: "佛山市禅城区佳铭达五金商行",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA+G4nQIbpg9",
            //             trackId: "LFKJ-WZO25-1102-01-W-WN",
            //             trackNumber: "LFWZ-W-2025-11-02-1",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-30 09:26:38",
            //         itemCount: 2,
            //         buyNumber: 8,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 612.88,
            //         status: 0,
            //     },
            //     {
            //         id: "l7GNWHA7TgqZRRXky2m5BTFxv60=",
            //         formId: "LFKJ-20260529-22916",
            //         supplierId: "4oIAAA+D9ag3xn38",
            //         supplier: "深圳市云鑫耀科技有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA+m8LEIbpg9",
            //             trackId: "LFKJ-WZO26-0308-01-N-XC",
            //             trackNumber: "LFWZ-N-2026-03-08",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-29 15:26:04",
            //         itemCount: 1,
            //         buyNumber: 7,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 387100,
            //         status: 0,
            //     },
            //     {
            //         id: "A7AR4eHDRfeL0xMzncXTszFxv60=",
            //         formId: "LFKJ-20260529-22915",
            //         supplierId: "4oIAAA+0Ogk3xn38",
            //         supplier: "广东人本机电有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA+wW1oIbpg9",
            //             trackId: "LFKJ-NZO26-0318-01-N",
            //             trackNumber: "LFWZ-N-2026-03-18",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-29 14:32:31",
            //         itemCount: 29,
            //         buyNumber: 91,
            //         outputNumber: 1,
            //         receiveNumber: 0,
            //         totalPrice: 5043.9,
            //         status: 1,
            //     },
            //     {
            //         id: "pU1v6sUOQCieZS2i9XgyLDFxv60=",
            //         formId: "LFKJ-20260529-22909",
            //         supplierId: "4oIAAA8M+4g3xn38",
            //         supplier: "佛山市禅城区佳铭达五金商行",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA9u69wIbpg9",
            //             trackId: "LFKJ-NZO25-0525-01-TH",
            //             trackNumber: "LFCK/TH2025-05-25",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-29 14:09:42",
            //         itemCount: 2,
            //         buyNumber: 3,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 1034,
            //         status: 0,
            //     },
            //     {
            //         id: "/F7Wot/+QHOawb6Yd4LIgDFxv60=",
            //         formId: "LFKJ-20260529-22905",
            //         supplierId: "4oIAAA+LH0E3xn38",
            //         supplier: "北京信联智合科技有限公司",
            //         userId: null,
            //         userName: null,
            //         project: {
            //             id: "4oIAAA+dZ3sIbpg9",
            //             trackId: "LFKJ-WZO26-0309-01-W",
            //             trackNumber: "LFWZ-W-2026-03-09",
            //             deleted: 0,
            //         },
            //         acceptFlag: 0,
            //         remark: null,
            //         createTime: "2026-05-29 11:24:53",
            //         itemCount: 2,
            //         buyNumber: 2,
            //         outputNumber: 0,
            //         receiveNumber: 0,
            //         totalPrice: 26500,
            //         status: 0,
            //     },
            // ];
            // this.total = this.table_data.length;
            this.table_loading = true;
            purchaseFormHeadQuery(this.searchobj, this)
                .then((res) => {
                    const records = res && Array.isArray(res.records) ? res.records : [];
                    this.table_data = records.map((item) =>
                        Object.assign({}, item, {
                            detailRows: [],
                            detailLoading: false,
                            detailLoaded: false,
                            detailFailed: false,
                        })
                    );
                    this.total = res && Number.isFinite(Number(res.total)) ? Number(res.total) : 0;
                })
                .catch(() => {
                    this.table_data = [];
                    this.total = 0;
                    this.loadFailed = true;
                })
                .finally(() => {
                    this.table_loading = false;
                });
        },
        syncOrderDate() {
            this.searchobj.startOrderDate = this.orderDateRange && this.orderDateRange[0] ? this.orderDateRange[0] : "";
            this.searchobj.endOrderDate = this.orderDateRange && this.orderDateRange[1] ? this.orderDateRange[1] : "";
        },
        search() {
            this.syncOrderDate();
            this.searchobj.currentPage = 1;
            this.getData();
        },
        resetSearch() {
            const pageSize = this.searchobj.pageSize;
            this.searchobj = createSearchobj();
            this.searchobj.pageSize = pageSize;
            this.orderDateRange = [];
            this.supplier_options = [];
            this.getData();
        },
        refresh() {
            this.getData();
        },
        handleSizeChange(size) {
            this.searchobj.pageSize = size;
            this.searchobj.currentPage = 1;
            this.getData();
        },
        handleCurrentChange(page) {
            this.searchobj.currentPage = page;
            this.getData();
        },
        async_supplier(query) {
            get_supplier(this, query);
        },
        showValue(value) {
            return value === null || value === undefined || value === "" ? "--" : typeof value === "number" ? parseFloat(value.toFixed(2)) : value;
        },
        showDate(value) {
            if (!value) return "--";
            return String(value).slice(0, 10);
        },
        supplierName(supplier) {
            if (supplier && typeof supplier === "object") {
                return this.showValue(supplier.supplierName || supplier.name);
            }
            return this.showValue(supplier);
        },
        amountValue(row) {
            return row.totalAmount !== null && row.totalAmount !== undefined && row.totalAmount !== "" ? row.totalAmount : row.totalPrice;
        },
        formatAmount(value) {
            if (value === null || value === undefined || value === "") return "--";
            const amount = Number(value);
            return Number.isFinite(amount) ? amount.toFixed(2) : "--";
        },
        normalizedStatus(row) {
            return row.statusName !== null && row.statusName !== undefined && row.statusName !== "" ? row.statusName : row.status;
        },
        statusText(row) {
            const status = this.normalizedStatus(row);
            const map = ["未发货", "部分发货", "在途", "部分签收", "签收完成"];
            if (status === null || status === undefined || status === "") return "--";
            if (/^[0-4]$/.test(String(status))) return map[Number(status)];
            return String(status);
        },
        statusType(row) {
            const status = this.statusText(row);
            if (status === "未发货") return "info";
            if (status === "部分发货") return "warning";
            if (status === "签收完成") return "success";
            return "";
        },
        sortOrderDate(a, b) {
            return String(a.orderDate || a.createTime || "").localeCompare(String(b.orderDate || b.createTime || ""));
        },
        sortAmount(a, b) {
            return (Number(this.amountValue(a)) || 0) - (Number(this.amountValue(b)) || 0);
        },
        sortStatus(a, b) {
            return this.statusText(a).localeCompare(this.statusText(b));
        },
        //打开上传文件弹窗
        openUpload(row) {
            this.currentRow = structuredClone(row);
            this.uploadShow = true;
        },
        //关闭上传文件弹窗
        uploadClose() {
            this.uploadShow = false;
            this.getData();
        },
        updateVisible(e) {
            this.viewOffice = e;
            this.$nextTick(() => {
                const dropdown = this.$refs[`dropdown-${this.currentRow.formId}`];
                if (dropdown) dropdown.show();
            });
        },
        //关闭图片预览弹窗
        imageClose() {
            this.img_show = false;
            this.$nextTick(() => {
                const dropdown = this.$refs[`dropdown-${this.currentRow.formId}`];
                if (dropdown) dropdown.show();
            });
        },
        countFileType(name) {
            if (name.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/)) return "图片";
            if (name.toLowerCase().match(/\.(pdf)$/)) return "PDF";
            return name.split(".").pop();
        },
        formatFileSize(bytes) {
            if (bytes === 0) return "0 B";
            const k = 1024;
            const sizes = ["B", "KB", "MB", "GB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
        },
        previewFile(file, row) {
            this.currentRow = structuredClone(row);
            const fileType = this.countFileType(file.originalName);
            if (fileType === "PDF") {
                fileApi
                    .viewFileApi(file.id, this)
                    .then((blob) => {
                        const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
                        const newWindow = window.open(blobUrl, "_blank");
                        if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
                            this.$message.warning("弹出窗口被阻止，请允许浏览器弹出窗口或手动下载后查看");
                            this.downloadBlob(blob, file.originalName);
                        }
                    })
                    .catch(() => {});
            } else if (fileType === "图片") {
                this.currentFileName = file.originalName;
                this.currentFilePath = file.id;
                this.img_show = true;
            } else if (["doc", "docx", "xls", "xlsx"].includes(file.originalName.split(".").pop().toLowerCase())) {
                this.currentViewFile = file;
                this.viewOffice = true;
            }
        },
        // 下载Blob
        downloadBlob(blob, filename) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 100);
        },
        downloadFile(file) {
            fileApi
                .viewFileApi(file.id, this)
                .then((blob) => {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = file.originalName;
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    }, 100);
                    this.$message.success(`开始下载: ${file.originalName} (${this.formatFileSize(file.size)})`);
                })
                .catch(() => {
                    this.$message.error("文件下载失败，请重试");
                });
        },
        delFile(file) {
            this.$confirm("确定删除该文件吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    fileApi
                        .delFileApi(file.id, this)
                        .then(() => {
                            this.$message.success("删除成功");
                            this.getData();
                        })
                        .catch(() => {
                            this.$message.error("删除失败");
                        });
                })
                .catch(() => {});
        },
        gotoDetail(row) {
            const formId = row.formId === null || row.formId === undefined ? "" : String(row.formId).trim();
            if (!formId) {
                this.$message.warning("订单号缺失，无法查看详情");
                return;
            }
            const { href } = this.$router.resolve({
                path: "/buyPage",
                query: { formId },
            });
            window.open(href, "_blank");
        },
    },
    created() {
        this.getData();
    },
    mounted() {
        this.showTime();
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = "";
        }
    },
};
</script>

<style scoped>
.buy-overview {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f2f3f5;
    font-family: "sonti", "Arial";
}

.overview-header {
    height: 52px !important;
    flex: 0 0 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    box-sizing: border-box;
    background: linear-gradient(135deg, #0faeb8 0%, #12b4bd 55%, #28c1c8 100%);
    box-shadow: 0 2px 10px rgba(18, 180, 189, 0.2);
}

.header-left {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}

.header-left img {
    width: 36px;
    height: 36px;
    object-fit: contain;
}

.header-text-left {
    flex-shrink: 0;
    font-size: 21px;
    line-height: 1;
    font-weight: 700;
    letter-spacing: 1px;
    color: #fff;
}

.pe-header-text {
    min-width: 0;
    margin-left: 6px;
    padding-left: 16px;
    border-left: 1px solid rgba(255, 255, 255, 0.38);
    font-size: 15px;
    line-height: 24px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.92);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.header-info {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 2px;
}

.header-right {
    line-height: 18px;
    font-size: 12px;
    text-align: right;
    color: rgba(255, 255, 255, 0.92);
}

.filter-card {
    margin: 12px 15px 0;
    padding: 14px 16px 4px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s ease;
}

.filter-card:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}

.filter-form {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.filter-form .el-form-item {
    margin-right: 16px;
    margin-bottom: 10px;
}

.filter-form ::v-deep .el-form-item__label {
    padding-right: 8px;
    font-weight: 500;
    color: #606266;
}

.filter-form .el-input,
.filter-form .el-select {
    width: 200px;
}

.filter-form ::v-deep .el-input__inner {
    border-color: #dcdfe6;
    border-radius: 4px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.filter-form ::v-deep .el-input__inner:hover {
    border-color: #a8abb2;
}

.filter-form ::v-deep .el-input__inner:focus {
    border-color: #12b4bd;
    box-shadow: 0 0 0 2px rgba(18, 180, 189, 0.1);
}

.filter-form .el-date-editor {
    width: 260px;
}

.filter-actions {
    margin-left: auto;
    margin-right: 0 !important;
}

.filter-actions ::v-deep .el-button {
    min-width: 76px;
    border-radius: 4px;
}

.filter-actions ::v-deep .el-button--primary {
    border-color: #12b4bd;
    background: #12b4bd;
}

.filter-actions ::v-deep .el-button--primary:hover,
.filter-actions ::v-deep .el-button--primary:focus {
    border-color: #0fa4ad;
    background: #0fa4ad;
}

.overview-content {
    min-height: 0;
    flex: 1;
    display: flex;
    gap: 12px;
    padding: 12px 15px;
    box-sizing: border-box;
}

.table-section {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.table-body {
    min-height: 0;
    flex: 1;
}

.table-body ::v-deep .el-table .cell {
    padding: 0 5px !important;
    line-height: 22px;
}

.table-body ::v-deep .el-table th {
    border-bottom-color: #dfe5ec;
    font-weight: 600;
}

.table-body ::v-deep .el-table td {
    border-bottom-color: #edf0f3;
}

.table-body ::v-deep .el-table__row {
    transition: background-color 0.18s ease;
}

.table-body ::v-deep .el-table__row:hover > td {
    background-color: #eefafa !important;
}

.table-body ::v-deep td.el-table__expand-column .cell {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
}

.table-body ::v-deep .el-table__expand-icon {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #12b4bd;
    border-radius: 4px;
    transition: background-color 0.2s ease;
}

.table-body ::v-deep .el-table__expand-icon:hover {
    background: rgba(18, 180, 189, 0.1);
}

.table-body ::v-deep .el-table__expand-icon > .el-icon {
    position: static;
    top: auto;
    left: auto;
    margin: 0;
    transform-origin: center;
}

.table-body ::v-deep .el-table__expand-icon--expanded > .el-icon {
    transform: rotate(90deg);
}

.table-body ::v-deep .el-table__expanded-cell {
    padding: 12px 14px !important;
    background: #f6f9fb;
    box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.04);
}

.detail-wrap {
    min-height: 60px;
}

.detail-message {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: #909399;
}

.detail-toolbar {
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border: 1px solid #dce7e9;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    background: #f7fbfb;
    color: #7a858c;
    font-size: 12px;
}

.detail-toolbar ::v-deep .el-button {
    min-width: 76px;
    min-height: 28px;
    margin-right: -6px;
    padding: 6px 10px;
    color: #0b969e;
    border-radius: 4px;
    font-weight: 600;
}

.detail-toolbar ::v-deep .el-button:not(.is-disabled):hover,
.detail-toolbar ::v-deep .el-button:not(.is-disabled):focus {
    background: rgba(18, 180, 189, 0.1);
}

.detail-toolbar ::v-deep .el-button:hover,
.detail-toolbar ::v-deep .el-button:focus {
    color: #08777d;
}

.detail-toolbar ::v-deep .el-button.is-disabled {
    color: #c0c4cc;
}

.detail-table {
    width: 100%;
    border-radius: 0 0 4px 4px;
    overflow: hidden;
}

.detail-table ::v-deep .el-table__header-wrapper th {
    height: 38px;
    padding: 6px 0 !important;
    border-bottom-color: #cfdfe1;
    background: #dceff1 !important;
    color: #26383a !important;
    font-size: 13px;
    font-weight: 700;
}

.detail-table ::v-deep .el-table__header-wrapper th .cell {
    line-height: 22px;
    color: #26383a !important;
    white-space: nowrap;
}

.detail-table ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.detail-table ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #12b4bd;
    background-color: #12b4bd;
}

.detail-table ::v-deep .detail-row-selectable {
    cursor: pointer;
}

.detail-table ::v-deep .detail-row-selectable:hover > td {
    background-color: #eefafa !important;
}

.detail-table ::v-deep .detail-row-selected > td,
.detail-table ::v-deep .detail-row-selected:hover > td {
    background-color: #dff4f5 !important;
    color: #24494b;
}

.detail-table ::v-deep .detail-row-selected > td:first-child {
    box-shadow: inset 3px 0 0 #12b4bd;
}

.detail-table ::v-deep .detail-row-disabled {
    cursor: not-allowed;
    color: #a8abb2;
    background-color: #fafafa;
}

.table-footer {
    min-height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-top: 1px solid #ebeef5;
    padding: 4px 0;
}

.table-footer ::v-deep .el-pagination {
    font-weight: 400;
}

.table-footer ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #12b4bd;
}

.table-footer ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #12b4bd;
}

.selected-panel {
    width: 410px;
    min-width: 380px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.selected-header {
    height: 52px;
    flex: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border-bottom: 1px solid #e8edf2;
    background: linear-gradient(180deg, #fff 0%, #fbfcfd 100%);
}

.selected-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.selected-title::before {
    content: "";
    width: 3px;
    height: 16px;
    margin-right: 8px;
    border-radius: 2px;
    background: #12b4bd;
}

.selected-title .el-tag {
    margin-left: 8px;
    border-color: rgba(18, 180, 189, 0.28);
    color: #0b969e;
    background: rgba(18, 180, 189, 0.08);
}

.selected-empty {
    min-height: 120px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #a2a7ae;
    font-size: 13px;
    background: linear-gradient(180deg, #fff 0%, #fafbfc 100%);
}

.selected-list {
    min-height: 0;
    flex: 1;
    overflow-y: auto;
    padding: 12px;
    scrollbar-width: thin;
    scrollbar-color: #cfd6dc transparent;
}

.selected-list::-webkit-scrollbar {
    width: 6px;
}

.selected-list::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #cfd6dc;
}

.selected-list::-webkit-scrollbar-track {
    background: transparent;
}

.selected-item {
    position: relative;
    margin-bottom: 10px;
    padding: 12px 12px 11px;
    border: 1px solid #e5eaef;
    border-left: 3px solid #b9dfe2;
    border-radius: 6px;
    background: #fafbfc;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.selected-item:last-child {
    margin-bottom: 0;
}

.selected-item:hover {
    border-color: #a9dfe2;
    border-left-color: #12b4bd;
    box-shadow: 0 3px 10px rgba(18, 180, 189, 0.1);
    background: #fff;
    transform: translateY(-1px);
}

.selected-item-head,
.quantity-row,
.count-row,
.selected-summary > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.selected-item-head {
    min-width: 0;
    padding-right: 26px;
}

.selected-item-head strong {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #303133;
    font-size: 14px;
    line-height: 20px;
}

.remove-button {
    position: absolute;
    top: 6px;
    right: 8px;
    z-index: 1;
    padding: 4px;
    font-size: 14px;
    color: #c0c4cc;
    border-radius: 50%;
    transition: color 0.2s ease, background-color 0.2s ease;
}

.remove-button:hover {
    color: #f56c6c;
    background: #fef0f0;
}

.quantity-row {
    gap: 12px;
    overflow: hidden;
}

.quantity-row span {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #7a828b;
}

.quantity-row .el-input-number {
    flex: 0 0 112px;
    width: 112px;
}

.quantity-row ::v-deep .el-input-number__decrease,
.quantity-row ::v-deep .el-input-number__increase {
    width: 28px;
    color: #606266;
    background: #f4f7f8;
}

.quantity-row ::v-deep .el-input-number__decrease:hover,
.quantity-row ::v-deep .el-input-number__increase:hover {
    color: #12b4bd;
}

.quantity-row ::v-deep .el-input__inner {
    padding-right: 28px;
    padding-left: 28px;
    border-color: #dfe5e9;
}

.count-row {
    /* margin-top: 10px; */
    /* padding-top: 9px; */
    border-top: 1px dashed #e5e9ed;
    font-size: 12px;
}

.item-amount {
    text-align: right;
    color: #e08b20;
    font-size: 14px;
    font-weight: 700;
}

.item-amount1 {
    text-align: left;
    color: #5e6973;
    font-weight: 500;
}

.selected-summary {
    flex: none;
    padding: 10px 16px;
    border-top: 1px solid #e4eaee;
    background: linear-gradient(180deg, #fafcfc 0%, #f6fafb 100%);
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.03);
}

.selected-summary > div {
    /* margin-bottom: 5px; */
    color: #68717a;
    font-size: 13px;
}

.selected-summary strong {
    color: #273239;
    font-size: 15px;
}

.selected-summary > div:nth-child(3) strong {
    color: #e08b20;
    font-size: 17px;
}

.selected-summary .el-button {
    width: 100%;
    height: 38px;
    margin-top: 6px;
    border-color: #12b4bd;
    border-radius: 4px;
    background: #12b4bd;
    font-weight: 600;
    letter-spacing: 1px;
    box-shadow: 0 3px 8px rgba(18, 180, 189, 0.2);
}

.selected-summary .el-button:hover,
.selected-summary .el-button:focus {
    border-color: #0fa4ad;
    background: #0fa4ad;
}

.selected-summary .el-button.is-disabled {
    border-color: #b8dfe1;
    background: #b8dfe1;
    box-shadow: none;
}

.page-footer {
    height: 26px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #fff;
    background-color: #12b4bd;
}

.empty-state {
    line-height: 30px;
}

.buy-overview ::v-deep .el-table {
    border-radius: 0;
}

.buy-overview ::v-deep .el-table th {
    background-color: #f5f7fa !important;
}

.buy-overview ::v-deep .el-table .cell {
    padding: 5px;
}

@media screen and (max-width: 1100px) {
    .overview-content {
        flex-direction: column;
        overflow-y: auto;
    }

    .table-section {
        min-height: 520px;
    }

    .selected-panel {
        width: 100%;
        min-width: 0;
        min-height: 300px;
        max-height: 480px;
    }
}

.file-item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: solid 1px #e4e7ed;
}

.file-name {
    flex: 1;
    text-align: left;
    margin-right: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-actions {
    display: flex;
    gap: 10px;
}

@media screen and (max-width: 900px) {
    .overview-header {
        padding: 0 12px;
    }

    .header-text-left {
        font-size: 18px;
    }

    .pe-header-text {
        margin-left: 2px;
        padding-left: 10px;
        font-size: 14px;
    }

    .header-info {
        margin-left: 12px;
    }

    .filter-card {
        margin-right: 10px;
        margin-left: 10px;
        padding-right: 12px;
        padding-left: 12px;
    }

    .overview-content {
        padding-right: 10px;
        padding-left: 10px;
    }

    .filter-actions {
        width: 100%;
        margin-left: 0;
    }
}

@media screen and (max-width: 640px) {
    .overview-header {
        height: 48px !important;
        flex-basis: 48px;
    }

    .header-left img {
        width: 30px;
        height: 30px;
    }

    .header-text-left {
        font-size: 16px;
        letter-spacing: 0;
    }

    .pe-header-text {
        display: none;
    }

    .header-info .header-right:first-child {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .header-info .header-right:last-child {
        display: none;
    }

    .filter-form .el-form-item {
        width: 100%;
        margin-right: 0;
    }

    .filter-form .el-input,
    .filter-form .el-select {
        width: 100% !important;
    }

    .filter-actions ::v-deep .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .filter-actions ::v-deep .el-button {
        flex: 1;
        margin-left: 0;
    }

    .table-footer {
        overflow-x: auto;
        justify-content: flex-start;
        padding-right: 8px;
        padding-left: 8px;
    }

    .selected-panel {
        max-height: 520px;
    }
}
</style>
